import { Token, User, Controller, Command, Team, NotificationPreferences } from './models'
import {getCurrentTeam} from "./dataHelpers/authenticationHelpers"


// Default to encrypted connection unless specified in env variables.
export const ENCRYPTED_CONNECTION = !process.env.REACT_APP_ENCRYPTED_CONNECTION.toLowerCase().includes("false")

export const VPN_MACHINE_NAME = window.location.href.includes("staging") ? "marksman-api-staging" : "marksman-api-prod"
                
export let environment = {
    WS_URL : `${ENCRYPTED_CONNECTION ? "wss" : "ws"}://${process.env.REACT_APP_API_URL}/api/channels`,
    API_URL : `${ENCRYPTED_CONNECTION ? "https" : "http"}://${process.env.REACT_APP_API_URL}/api`,
    API_APP_ID : "aK4KWaz1GDVl8YKmYu77iZw7Kb896cunzO1wDOPA",
    API_KEY : "u2xqsrRiMrJ1sEuH0VPPrcDQUwxDAo6ekYh8S5fNoDYBDlZH6uSYkyZVfG8FoszMU7vm5bfjakFoaNCrZCqveKeQlTHFpx8on3kNFqCYRVqHT5IJmyZ7F6iEWQzM8jIx",
    MAPS_API_KEY : "AIzaSyBYk8QxutMP3DG2juKVDDy_slb1vpdr_NY",
    NEW_MAPS_API_KEY : "AIzaSyCvwlmeTE9oYvsEuOOYOrGi3EWWvcBAXYg",
    SHOW_HELP_LINK : false,
    RESPONSE_PAGE_SIZE: 10,
    JD_API_URL: "https://sandboxapi.deere.com/platform",
    JD_CALLBACK_URL: "https://marksman.surepointag.com/team/?tab=3&jdIntegrated=true",
    ADMIN_URL: `${ENCRYPTED_CONNECTION ? "https" : "http"}://${process.env.REACT_APP_API_URL}/admin/`,
    GRAFANA_URL: `${ENCRYPTED_CONNECTION ? "https" : "http"}://${process.env.REACT_APP_API_URL}/grafana/d/O6v4rMpizda/django?orgId=1&refresh=30s`,
    SERVER_LOG_URL: 'https://my.papertrailapp.com/groups/31629631/events',
}


export const WS_URL = environment.WS_URL
export const MAPS_API_KEY = environment.MAPS_API_KEY
export const NEW_MAPS_API_KEY = environment.NEW_MAPS_API_KEY
export const RESPONSE_PAGE_SIZE = environment.RESPONSE_PAGE_SIZE
export const SHOW_HELP_LINK = environment.SHOW_HELP_LINK
export const ADMIN_URL = environment.ADMIN_URL
export const GRAFANA_URL = environment.GRAFANA_URL
export const SERVER_LOG_URL = environment.SERVER_LOG_URL


export async function authenticate(username, password) {
    const encoded_username = encodeURIComponent(username.toLowerCase())
    const encoded_password = encodeURIComponent(password)
    const endpoint = `${environment.API_URL}/o/token/?grant_type=password&username=${encoded_username}&password=${encoded_password}`

    let headers = new Headers()
    const auth_header_info = btoa(environment.API_APP_ID + ":" + environment.API_KEY)
    headers.append('Authorization', `Basic ${auth_header_info}`);

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return new Token(data.access_token, data.refresh_token, data.expires_in)
}


export async function refreshToken(token) {
    const endpoint = `${environment.API_URL}/o/token/?grant_type=refresh_token&refresh_token=${token.refreshToken}`

    let headers = new Headers()
    const auth_header_info = btoa(environment.API_APP_ID + ":" + environment.API_KEY)
    headers.append('Authorization', `Basic ${auth_header_info}`);

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return new Token(data.access_token, data.refresh_token, data.expires_in)
}

export async function revokeToken(token) {
    const endpoint = `${environment.API_URL}/o/revoke_token/?token=${token.accessToken}&client_id=${environment.API_APP_ID}`

    let headers = new Headers()
    const auth_header_info = btoa(environment.API_APP_ID + ":" + environment.API_KEY)
    headers.append('Authorization', `Basic ${auth_header_info}`);

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers
    })

    let data = {}
    try {
        data = await response.json()
    } catch (err) {
        // This will only err if response is null after successful logout
    }
    await checkServerResponseForErrors(response)
    checkSerializedResponseForErrors(data)
}


export async function getStatusLogForController(token, controller, start, end) {
    let endpoint = `${environment.API_URL}/statuses/?controller=${controller}`
    if (start) {
        let day = start.getDate()
        if (String(day).length < 2) {
            day = `0${day}`
        }
        let month = start.getMonth()+1
        if (String(month).length < 2) {
            month = `0${month}`
        }
        let year = start.getFullYear()
        endpoint += `&start=${year}-${month}-${day}-00-00`
    }
    if (end) {
        let day = end.getDate()
        if (String(day).length < 2) {
            day = `0${day}`
        }
        let month = end.getMonth()+1
        if (String(month).length < 2) {
            month = `0${month}`
        }
        let year = end.getFullYear()
        endpoint += `&end=${year}-${month}-${day}-23-59`
    }
    console.log("Endpoint: " + endpoint)
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')
    headers.append('Accept', 'text/csv')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    return response.text()
}


export async function getCurrentUser(token) {
    let endpoint = `${environment.API_URL}/current_user/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return User.fromAPIObject(data, getCurrentTeam())
}

export async function getTeam(token, id, serializer) {
    let endpoint = `${environment.API_URL}/teams/${id}/`

    if (serializer) {
        endpoint += `?serializer=${serializer}`
    }

    let headers = new Headers();
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    let t = Team.fromAPIObject(data)
    return t
}

export async function getUser(token, id, activeTeam=null) {
    let endpoint = `${environment.API_URL}/users/${id}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return User.fromAPIObject(data, activeTeam)
}

export async function updateUser(token, user, newPassword) {
    let endpoint = `${environment.API_URL}/users/${user.id}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newUser = {
        first_name : user.firstName,
        last_name : user.lastName,
        username : user.email,
        email : user.email,
    }

    if (user.notificationPreferences && user.notificationPreferences.length) {
        newUser['notification_preferences'] = user.notificationPreferences.map(p => NotificationPreferences.fromDictionary(p).toAPIObject())
    }

    if (newPassword) {
        newUser.new_password = newPassword
    }

    let response = await fetch(endpoint, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(newUser)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return User.fromAPIObject(data, user.activeTeam)
}

export async function updateField(token, field) {
    let endpoint = `${environment.API_URL}/fields/${field.id}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(field)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

export async function deleteField(token, fieldID) {
    let endpoint = `${environment.API_URL}/fields/${fieldID}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        id: fieldID
    }

    let response = await fetch(endpoint, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(newField)
    })

    return
}

export async function createField(token, fieldNumber, fieldName, teamID) {
    let endpoint = `${environment.API_URL}/fields/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        team: teamID,
        field_number: fieldNumber,
        name: fieldName
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

export async function updateController(token, controller) {
    let endpoint = `${environment.API_URL}/controllers/${controller.id}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newController = {
        id: controller.id,
        name: controller.name,
        current_chemical: controller.currentChemical,
        tank_size: controller.tankSize,
        water_reporting_units: controller.waterReportingUnits,
        max_gauge_chem_rate: controller.maxGaugeChemRate
    }

    let response = await fetch(endpoint, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(newController)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return Controller.fromAPIObject(data)
}

export async function updateTeam(token, team, remove_member_id=null) {
    let endpoint = `${environment.API_URL}/teams/${team.id}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newTeam = {
        id: team.id,
        name: team.name,
        remove_member: remove_member_id
    }

    if (team.permissions) {
        newTeam['member_permissions'] = team.permissions
    }

    let response = await fetch(endpoint, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(newTeam)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return Team.fromAPIObject(data)
}

export async function getController(token, id, serializeTeams=false) {
    let endpoint = `${environment.API_URL}/controllers/${id}/`
    if (serializeTeams) {
        endpoint = endpoint + '?serialize_teams=true'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return Controller.fromAPIObject(data)
}

export async function getStatusesForController(token, controller, start, end) {
    let endpoint = `${environment.API_URL}/statuses/?controller=${controller}`
    if (start) {
        endpoint += `&start=${start}`
    }
    if (end) {
        endpoint += `&end=${end}`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data
}

export async function getExtendedDataPointsForController(controller, start_date, end_date) {
    // TODO
}

export async function getCommandHistoryForController(token, controllerID) {
    let endpoint = `${environment.API_URL}/commands/?controller=${controllerID}&page_size=100&serialize_users=true`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers,
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    let {results, count} = data
    return {results:results.map(r => Command.fromAPIObject(r)).filter(c => c.sentBy && c.sentBy != "-"), count}
}

export async function sendCommand(token, command) {
    let endpoint = `${environment.API_URL}/commands/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(command.toAPIObject())
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return Command.fromAPIObject(data)
}

/* PRAGMA: Support Only API */

export async function provisionController(token, serialNumber, iccid, phone, username, password, legacyAccess=false, forceReprovision=false) {
    if (!username || username.length < 5) {
        throw new Error("Username cannot be shorter than 5 characters")
    } else if (!password || password.length < 5) {
        throw new Error("Password cannot be shorter than 5 characters")
    }
    
    let endpoint = `${environment.API_URL}/management/provision_controller/?legacy_access=${legacyAccess}`
    if (serialNumber) {
       endpoint = `${endpoint}&serial_number=${serialNumber}`
    }
    if (iccid) {
        endpoint = `${endpoint}&iccid=${iccid}`
     }
    if (phone) {
        endpoint = `${endpoint}&phone=${phone}`
    }
    if (forceReprovision) {
        endpoint = `${endpoint}&force_reprovision=${forceReprovision}`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newUser = {
        first_name : `Controller-${username}`,
        last_name : "Marksman",
        username : username,
        password : password
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newUser)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return Controller.fromAPIObject(data)
}


export async function lookupControllerBySerialNumber(token, serialNumber, fuzzySearch=false, hideAssigned=true, hideArchived=true, teamID=null) {
    if (!serialNumber || serialNumber.length < 1) {
        throw new Error("Phone number cannot be blank")
    }

    let endpoint = `${environment.API_URL}/management/lookup/controller/?serial_number=${serialNumber}`
    if (fuzzySearch) {
        endpoint += `&fuzzy_search=true`
    }

    if (hideAssigned) {
        endpoint += '&assigned=false'
    }

    if (hideArchived) {
        endpoint += '&archived=false'
    }

    if (teamID) {
        endpoint += `&team=${teamID}`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    if (fuzzySearch) {
        return data.map((c) => Controller.fromAPIObject(c))
    }

    return Controller.fromAPIObject(data)
}


export async function lookupUserByEmail(token, email) {
    if (!email || email.length < 1) {
        throw new Error("Email cannot be blank")
    }

    email = email.toLowerCase()

    let endpoint = `${environment.API_URL}/management/lookup/user/?email=${email}`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    let user = User.fromAPIObject(data)
    if (user.teams && user.teams.length) {
        user.teams = user.teams.map(t => Team.fromAPIObject(t))
    }
    return user
}


export async function assignControllers(token, controllerIDs, customerTeamID, serializeTeams = false) {
    if (typeof(controllerIDs) !== "object" || controllerIDs.constructor !== Array) {
        throw new Error("Controller IDs must be an array")
    }
    if (!controllerIDs || controllerIDs.length < 1) {
        throw new Error("Controller IDs cannot be empty")
    }
    if (!customerTeamID) {
        throw new Error("Customer Team ID cannot be empty")
    }

    let endpoint = `${environment.API_URL}/management/assign_controllers/?controllers=${controllerIDs.join(',')}`
    if (customerTeamID && customerTeamID > 0) {
        endpoint += `&customer_team_id=${customerTeamID}`
    }

    if (serializeTeams) {
        endpoint = endpoint + '&serialize_teams=true'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data.map((c) => Controller.fromAPIObject(c))
}


export async function registerControllers(token, controllerSerials, dealerTeamID, serializeTeams=false) {
    if (typeof(controllerSerials) !== "object" || controllerSerials.constructor !== Array) {
        throw new Error("Controller serial numbers must be an array")
    }
    if (!controllerSerials || controllerSerials.length < 1) {
        throw new Error("Controller serial numbers cannot be empty")
    }
    if (!dealerTeamID) {
        throw new Error("Dealer Team ID cannot be empty")
    }

    let endpoint = `${environment.API_URL}/management/register_controllers/`

    if (serializeTeams) {
        endpoint = endpoint + '?serialize_teams=true'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            serial_numbers: controllerSerials,
            dealer_team_id: dealerTeamID,
        }),
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data.map((c) => Controller.fromAPIObject(c))
}


export async function unassignControllers(token, controllerIDs, dealerTeamID) {
    if (typeof(controllerIDs) !== "object" || controllerIDs.constructor !== Array) {
        throw new Error("Controller IDs must be an array")
    }
    if (!controllerIDs || controllerIDs.length < 1) {
        throw new Error("Controller IDs cannot be empty")
    }
    if (!dealerTeamID) {
        throw new Error("Dealer Team ID cannot be empty")
    }

    let endpoint = `${environment.API_URL}/management/unassign_controllers/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            controller_ids: controllerIDs,
            dealer_team_id: dealerTeamID,
        }),
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data.results.map((result) => ({
        controller: Controller.fromAPIObject(result.controller),
        archivedControllerID: result.archived_controller_id,
    }))
}

export async function assignControllersToDealer(token, controllerIDs, dealerTeamID) {
    if (!controllerIDs || controllerIDs.constructor !== Array || controllerIDs.length < 1) {
        throw new Error("Controller IDs cannot be empty")
    }
    if (!dealerTeamID) {
        throw new Error("Dealer Team ID cannot be empty")
    }
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')
    let response = await fetch(`${environment.API_URL}/management/assign_controllers_to_dealer/`, {
        method: 'POST',
        headers,
        body: JSON.stringify({controller_ids: controllerIDs, dealer_team_id: dealerTeamID}),
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data.map((controller) => Controller.fromAPIObject(controller))
}

export async function getAllUsers(token, useMicroSerializer = false, page = 1, pageSize = RESPONSE_PAGE_SIZE) {

    let endpoint = `${environment.API_URL}/users/?page_size=${pageSize}&page=${page}&utility=false`
    if (useMicroSerializer) {
        endpoint = endpoint + '&serializer=micro'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return {count: data.count, results: data.results.map((t) => User.fromAPIObject(t))}
}

export async function getAllTeams(token, showDealers, showCustomers, useMicroSerializer = false, usePicoSerializer = false, page = 1, pageSize = RESPONSE_PAGE_SIZE) {

    let endpoint = `${environment.API_URL}/teams/?page_size=${pageSize}&page=${page}&show_dealers=${showDealers}&show_customers=${showCustomers}&sortBy=name`

    if (useMicroSerializer) {
        endpoint = endpoint + '&serializer=micro'
    } else if (usePicoSerializer) {
        endpoint = endpoint + '&serializer=pico'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return {count: data.count, results: data.results.map((t) => Team.fromAPIObject(t))}
}

export async function getPastControllers(token, teamId=null, serializeTeams=false, page=1, pageSize=RESPONSE_PAGE_SIZE, sortBy="", sortDescending=false,phone = "", selectedOption = "", showArchived = "", useMicroSerializer=false) {
    if (!page) {
        page = 1
    }

    if (sortBy == null || sortBy == "null") {
        sortBy = ""
    }

    let endpoint = `${environment.API_URL}/management/past_controllers/?page_size=${pageSize}&page=${page}&sort_by=${sortBy}&sort_descending=${sortDescending}&search=${phone}&option=${selectedOption}&showArchived=${showArchived}`
    if (teamId) {
        endpoint = `${endpoint}&team=${teamId}`
    }
    if (serializeTeams) {
        endpoint = `${endpoint}&serialize_teams=true`
    }
    if (useMicroSerializer) {
        endpoint = `${endpoint}&serializer=micro`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return {count: data.count, results: data.results.map((c) => Controller.fromAPIObject(c))}
}

export async function getControllers(token, teamID, serializeTeams = false, useMicroSerializer = false, hideArchived = false, page = 1, pageSize = RESPONSE_PAGE_SIZE, sortBy = "", sortDescending = false, phone = "", selectedOption = "", showArchived = "") {
    if (!teamID) {
        throw new Error("Team ID cannot be empty")
    }

    let endpoint = `${environment.API_URL}/controllers/?team=${teamID}&page_size=${pageSize}&page=${page}&sort_by=${sortBy}&sort_descending=${sortDescending}&search=${phone}&option=${selectedOption}&showArchived=${showArchived}`
    if (serializeTeams) {
        endpoint = endpoint + '&serialize_teams=true'
    } else if (useMicroSerializer) {
        endpoint = endpoint + '&serializer=micro'
    }

    if (hideArchived) {
        endpoint = endpoint + '&archived=false'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return {count: data.count, results: data.results.map((c) => Controller.fromAPIObject(c))}
}

export async function getDealerControllers(token, dealerTeamID, assignmentState, page = 1, pageSize = RESPONSE_PAGE_SIZE, sortBy = "", sortDescending = false, search = "", selectedOption = "") {
    if (!dealerTeamID) {
        throw new Error("Dealer Team ID cannot be empty")
    }
    if (["dealer", "unassigned", "customer"].indexOf(assignmentState) < 0) {
        throw new Error("Invalid dealer controller state")
    }

    let endpoint = `${environment.API_URL}/controllers/?dealer_team_id=${dealerTeamID}&assignment_state=${assignmentState}&page_size=${pageSize}&page=${page}&sort_by=${sortBy || ""}&sort_descending=${sortDescending}&search=${search || ""}&option=${selectedOption || ""}&serializer=micro`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {method: 'GET', headers})
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return {count: data.count, results: data.results.map((c) => Controller.fromAPIObject(c))}
}

export async function getAllControllers(token, useMicroSerializer = false, usePicoSerializer = false, serializeTeams = false, hideAssigned = false, hideUnassigned = false, hideArchived = false, page = 1, pageSize = RESPONSE_PAGE_SIZE, search) {
    let endpoint = `${environment.API_URL}/controllers/?page_size=${pageSize}&page=${page}`
    
    if (search) {
        endpoint = endpoint + `&search=${search}`
    }

    if (serializeTeams) {
        endpoint = endpoint + '&serialize_teams=true'
    } else if (useMicroSerializer) {
        endpoint = endpoint + '&serializer=micro'
    } else if (usePicoSerializer) {
        endpoint = endpoint + '&serializer=pico'
    }

    if (hideAssigned) {
        endpoint = endpoint + '&assigned=false'
    } else if (hideUnassigned) {
        endpoint = endpoint + '&assigned=true'
    }

    if (hideArchived) {
        endpoint = endpoint + '&archived=false'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return {count: data.count, results: data.results.map((c) => Controller.fromAPIObject(c))}
}

export async function provisionTeam(token, teamName, adminEmail, controllerSerials=[], dealership=false) {
    if (!teamName) {
        throw new Error("Must include team name parameter")
    } else if (!adminEmail || adminEmail.length < 5) {
        throw new Error("Must include admin email parameter")
    }

    let endpoint = `${environment.API_URL}/management/provision_team/?team_name=${teamName}`
    if (controllerSerials.length > 0) {
        endpoint = endpoint + `&controller_serials=${controllerSerials.join(',')}`
    }
    if (dealership) {
        endpoint = endpoint + `&dealership=${dealership}`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newUser = {
        username : adminEmail,
        email : adminEmail,
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newUser)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return Team.fromAPIObject(data)
}

export async function inviteUser(token, email, teamID) {
    if (!teamID) {
        throw new Error("Must include team id parameter")
    } else if (!email || email.length < 5) {
        throw new Error("Must include email parameter")
    }

    let endpoint = `${environment.API_URL}/team/add_user/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newUser = {
        username : email,
        email : email,
        teams : [teamID]
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newUser)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return User.fromAPIObject(data, teamID)
}


export async function signUpUser(firstName, lastName, password, userID, signUpCode) {
    if (!firstName) {
        throw new Error("Must include first name")
    } else if (!lastName ) {
        throw new Error("Must include last name")
    } else if (!userID) {
        throw new Error("Must include user id")
    } else if (!password) {
        throw new Error("Must include password")
    }

    let endpoint = `${environment.API_URL}/signup/?c=${signUpCode}&u=${userID}`

    let headers = new Headers()
    headers.append('Content-Type', 'application/json')

    let newUser = {
        first_name : firstName,
        last_name : lastName,
        password : password
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newUser)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return User.fromAPIObject(data)
}
/*
This function sends the request for selected controllers by users
for acheiving the Delete controllers functionality form the list
*/
export async function sendArchiveController(token, controllerID){
    let endpoint = `${environment.API_URL}/deletearchive/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')
    let controllerData = {
      controller_id:controllerID
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(controllerData)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}
export async function transferControllerID(fromDate, toDate, fromPhone, toPhone, token) {
    if (!fromDate) {
        throw new Error("Must include From Date Field")
    } 
    else if (!toDate ) {
        throw new Error("Must include to date field")
    } 
    else if (!fromPhone) {
        throw new Error("Must include from phone field")
    } else if (!toPhone) {
        throw new Error("Must include to phone field")
    }

    let endpoint = `${environment.API_URL}/transferdata/`

    let headers = new Headers()
    
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let controllerData = {
        from_date : fromDate,
        to_date : toDate,
        from_phone : fromPhone,
        to_phone :toPhone
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(controllerData)
    })

    const data = await response.json()
    return data
}

export async function requestPasswordReset(email) {
    if (!email) {
        throw new Error("Must include email")
    }

    let endpoint = `${environment.API_URL}/forgot_password/?email=${email}`

    let headers = new Headers()
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data
}

export async function resetPassword(userID, oneTimeCode, newPassword) {
    if (!oneTimeCode) {
        throw new Error("Must include one time code")
    } else if (!userID) {
        throw new Error("Must include user id")
    } else if (!newPassword) {
        throw new Error("Must include new password")
    }

    let endpoint = `${environment.API_URL}/forgot_password/?c=${oneTimeCode}&u=${userID}`

    let headers = new Headers()
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({new_password: newPassword})
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data
}


/**
 * Gets the Integration Object associated with the provided team
 * @param {Number} teamID 
 * @param {Token} token 
 * @returns An Integration associated with the provided team. Returns undefined if no matching team/integration is found.
 */
export async function getIntegrationForTeam(teamID, token) {
    let headers = new Headers();
    headers.append('Authorization', `Bearer ${token.accessToken}`);
    headers.append('Content-Type', 'application/json');
    
    try {
        let endpoint = `${environment.API_URL}/integrations/jdo/?show_incomplete=true&team=${teamID}`;
        let response = await fetch(endpoint, {
            method: 'GET',
            headers: headers
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let integrations = await response.json();
        for (let integration of integrations) {
            if (integration.team === teamID) {
                //console.log("Integration Data: ", integration);
                return integration;
            }
        }
    } catch (error) {
        console.error("A fetch error occurred: ", error);
        // Handle error as needed
        return null;
    }
}

/**
 * Loads the teams associated with a John Deere Integration (Connection Unverified)
 * @param {Number} integrationID 
 * @param {Token} token 
 * @returns {List} A list of the associated JD Orgs
 */
export async function loadExternalTeams(integrationID, token) {
    
    let headers = new Headers();
    headers.append('Authorization', `Bearer ${token.accessToken}`);
    headers.append('Content-Type', 'application/json');
    try {
        let endpoint = `${environment.API_URL}/integrations/jdo/${integrationID}/load_external_teams/`;
        let response = await fetch(endpoint, {
            method: 'PATCH',
            headers: headers
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        let data = await response.json();
        //console.log("Integration Data: ", data);
        return data.available_external_teams;
    } catch (error) {
        console.error("A fetch error occurred: ", error);
    }
}

/**
 * Deletes the John Deere Ops Center Integration associated
 * with the team ID provided. Removes all assets from ops 
 * center as well as deleting the integration from our database
 * @param {Number} teamID 
 * @param {Token} token 
 */
export async function disableJDOpsCenterIntegrationForTeam(teamID, token) {
    let integration = await getIntegrationForTeam(teamID, token);
    let integrationID = integration.id
    let endpoint = `${environment.API_URL}/integrations/jdo/${integrationID}/`;

    let headers = new Headers();
    headers.append('Authorization', `Bearer ${token.accessToken}`);
    headers.append('Content-Type', 'application/json');

    let response = await fetch(endpoint, {
        method: 'DELETE',
        headers: headers
    });

    await checkServerResponseForErrors(response);
}

async function checkServerResponseForErrors(response) {
    if (response.status >= 200 && response.status < 300) {
        // All good, 200 OK, 201 CREATED, etc
        return
    } else if (response.status >= 400 && response.status < 500 ) {
        let data = await response.json()
        let message
        if (data.error && data.error_description && data.error === "invalid_grant") {
            message = 'Email address or password incorrect.'
        } else {
            message = await JSON.stringify(data)
            if (message.startsWith('["')) {
                message = message.replace('["', '').replace('"]', '')
            }
        }
        throw new Error(message)
    } else {
        throw new Error (`${response.status}: ${response.statusText}`)
    }
}


//////////////////////////////////////////////
/*** Start code for subscription module ***/
//////////////////////////////////////////////

/** API for get All Plan List **/

export async function planlist(token) {
    //let endpoint = `${environment.API_URL}/subscription_plan/`
    let endpoint = `${environment.API_URL}/all_subscription_plan/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get All Plan List **/

export async function activePlanlist(token) {
    //let endpoint = `${environment.API_URL}/subscription_plan/`
    let endpoint = `${environment.API_URL}/active_subscription_plan/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get All Subscription Plan data with Year & Price **/

export async function allplanlist(token) {
    let endpoint = `${environment.API_URL}/all_subscription_plan/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get Subscription Plan data for controller **/

export async function mySubscriptionPlanData(token, controllerId) {
    let endpoint = `${environment.API_URL}/get_controller_subscription/?controller_id=${controllerId}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for set/update initial free subscription plan days **/

export async function setInitialSubsPlanDays(token, subsPlanDayVal, selectPlanID) {

    let endpoint = `${environment.API_URL}/set_init_sub_days/${selectPlanID}/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        subscription_days: subsPlanDayVal,
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for assign controller to team with subscription plan **/

export async function assignControllerTeam(token, controllerIDs, customerTeamID, subsPlanID, is_seasonedVal, pastTeamID, serializeTeams = false, assignBySupportUser = false) {
    if (typeof (controllerIDs) !== "object" || controllerIDs.constructor !== Array) {
        throw new Error("Controller IDs must be an array")
    }
    if (!controllerIDs || controllerIDs.length < 1) {
        throw new Error("Controller IDs cannot be empty")
    }
    if (!customerTeamID) {
        throw new Error("Customer Team ID cannot be empty")
    }
    if (!subsPlanID) {
        throw new Error("Subscription Plan ID cannot be empty")
    }

    let endpoint = `${environment.API_URL}/assign_controller_team_subscription/?controller_ids=${controllerIDs.join(',')}`
    if (customerTeamID && customerTeamID > 0) {
        endpoint += `&customer_team_id=${customerTeamID}`
    }

    if (subsPlanID && subsPlanID > 0) {
        endpoint += `&subscription_plan_id=${subsPlanID}&is_seasoned=${is_seasonedVal}`
    }

    if (pastTeamID) {
        endpoint += `&past_team_id=${pastTeamID}`
    }

    if (serializeTeams) {
        endpoint = endpoint + '&serialize_teams=true'
    }

    if (assignBySupportUser) {
        endpoint = endpoint + '&support_user=true'
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    let d = data
    console.log("API DATA:")
    console.log(d)
    console.log("API CONTROLLER DATA:")
    console.log(d.controller_data)
    return data.controller_data.map((c) => Controller.fromAPIObject(c))
}

/** API for extend subscription plan days **/

export async function extendSubscriptionDays(token, controllerID, extendDaysVal) {

    let endpoint = `${environment.API_URL}/extend_subscription_days/?controller_id=${controllerID}&extended_days=${extendDaysVal}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create subscription plan **/

export async function createSubscriptionPlan(token, planNameVal, isFreePlan = false, freePlanVal) {
    if (!planNameVal || planNameVal.length < 1) {
        throw new Error("Subscription plan name cannot be empty")
    }

    if (isFreePlan) {
        if (!freePlanVal || freePlanVal.length < 1) {
            throw new Error("Subscription free days cannot be empty")
        }
    }

    let endpoint //= `${environment.API_URL}/create_subscription_plan/?subsplan_name=${planNameVal.join(',')}`

    if (isFreePlan) {
        endpoint = `${environment.API_URL}/create_subscription_plan/?subsplan_name=${planNameVal}&is_seasoned=False&subscription_days=${freePlanVal}`
    } else {
        endpoint = `${environment.API_URL}/create_subscription_plan/?subsplan_name=${planNameVal}&is_seasoned=True&subscription_days=0`
        //endpoint = endpoint + `&is_seasoned=false&subscription_days=0`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for renew subscription plan **/

export async function renewSubscriptionPlan(token, controllerID) {

    if (!controllerID || controllerID.length < 1) {
        throw new Error("Controller id cannot be empty")
    }

    let endpoint = `${environment.API_URL}/renew_subscription_plan/?controller_id=${controllerID}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for renew bulk subscription plan **/

export async function renewBulkSubscriptionPlan(token, bulk_subsData) {

    let endpoint = `${environment.API_URL}/bulk_update/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bulk_subsData)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get all controllers with subscription plan & team **/

export async function getSubsControllers(token, teamID) {
    let endpoint = `${environment.API_URL}/sub_controllers/?team=${teamID}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)

    return data.results.map((c) => Controller.fromAPIObject(c))
    //return data
}

/** API for get all controllers with subscription plan **/

export async function subsControllerlist(token) {
    let endpoint = `${environment.API_URL}/subscription_controller/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get create payment details **/

export async function chargePayment(token, amount, paymentToken, secretToken) {

    let endpoint = `${environment.API_URL}/subscription_payment/?amount=${amount}&secret_token=${secretToken}&payment_token=${paymentToken}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for save payment details **/

export async function savePaymentData(token, transactionID, transDetails, randomTransactionId, paidBy, controllerID) {

    if (!transactionID || transactionID.length < 1) {
        throw new Error("Transaction id cannot be empty")
    }

    let endpoint = `${environment.API_URL}/subs_all_payment/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        random_transaction_id: randomTransactionId,
        transaction_id: transactionID,
        paid_by: paidBy,
        controllers: controllerID,
        detail: transDetails
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get sunbscription plan price **/

export async function subscriptionPlanPrice(token, subsPlanId, subsPlanYear) {
    let endpoint
    if (subsPlanId && subsPlanYear) {
        endpoint = `${environment.API_URL}/subscription_price/?subsplan_id=${subsPlanId}&subsplan_year=${subsPlanYear}`
    } else {
        endpoint = `${environment.API_URL}/subscription_price/`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create subscription plan price **/

export async function createSubscriptionPrice(token, planId, planPrice, planYear) {
    if (!planPrice || planPrice.length < 1) {
        throw new Error("Subscription plan price cannot be empty")
    }

    if (!planYear || planYear.length < 1) {
        throw new Error("Subscription plan price cannot be empty")
    }

    let endpoint = `${environment.API_URL}/create_subs_price/?subsplan_id=${planId}&subsplan_price=${planPrice}&subsplan_year=${planYear}`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get sunbscription plan price **/

export async function subscriptionInvoice(token, teamArr) {

    let endpoint
    if (teamArr == -1) {
        endpoint = `${environment.API_URL}/subscription_invoice/`
    } else {
        //endpoint = `${environment.API_URL}/subscription_invoice/?teams=${JSON.stringify(teamArr)}`
        endpoint = `${environment.API_URL}/subscription_invoice/?teams=${teamArr}`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get All Subscription Plan data with Year & Price **/

export async function allcontrollerstatus(token, teamId) {
    let endpoint = `${environment.API_URL}/subscription_controller_status/`
    if (teamId) {
        endpoint = endpoint + `?team=${teamId}`
    }

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get payment history of each controller **/

export async function subsControllerPaymentDetails(token, controllerId) {

    //let endpoint = `${environment.API_URL}/get_payment_details/?controller=${controllerId}`
    let endpoint = `${environment.API_URL}/subs_all_payment/${controllerId}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for update subscription plan price & year **/

export async function updateSubsPlanPrice(token, subsPlanPrice, subsPlanYear, selectPlanID) {

    let endpoint = `${environment.API_URL}/subscription_price/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        subscription_plan: parseInt(selectPlanID),
        subscription_price: subsPlanPrice,
        subscription_year: subsPlanYear
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get dealers list **/

export async function getDealers(token) {
    let endpoint = `${environment.API_URL}/get_users_group/?group=Dealers`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get dealers team list **/

export async function getDealersTeam(token, dealerIdArr) {
    let endpoint = `${environment.API_URL}/get_dealer_team_list/?dealers=${JSON.stringify(dealerIdArr)}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get default sunbscription plan price **/

export async function defaultSubscriptionPlan(token, teamArr) {
    let endpoint = `${environment.API_URL}/get_default_subs_plan/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for update default subscriptoin plan  **/

export async function updateDefaultSubsPlan(token, selectPlanID, selectPlanIdPkId) {
    if (!selectPlanID) {
        throw new Error("default plan id cannot be empty")
    }

    let endpoint = `${environment.API_URL}/get_default_subs_plan/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        "id": parseInt(selectPlanIdPkId),
        "SubscriptionPlan": selectPlanID
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get All Assigned Dealer Subscription Discount **/

export async function allAssignedDiscountList(token) {
    let endpoint = `${environment.API_URL}/discount/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get Single team Discount **/

export async function getTeamDiscount(token, teamId) {
    let endpoint = `${environment.API_URL}/discount/${teamId}/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for assign discount label to team **/

export async function assignSubscriptionDiscount(token, teamId, discountVal) {
    if (!teamId) {
        throw new Error("Dealer id cannot be empty")
    }

    if (!discountVal) {
        throw new Error("Discount value cannot be empty")
    }

    let endpoint = `${environment.API_URL}/discount/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        discount: discountVal,
        team: teamId,
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for update assigned subscription discount label for dealer **/

export async function updateSubsAssignedDiscount(token, teamId, discountId) {
    if (!teamId) {
        throw new Error("Dealer id cannot be empty")
    }

    if (!discountId) {
        throw new Error("Discount value cannot be empty")
    }

    let endpoint = `${environment.API_URL}/discount/${teamId}/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        discount: discountId,
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create discount label **/

export async function addDiscountLabel(token, discountLabel, discountVal) {
    if (!discountLabel) {
        throw new Error("Discount label cannot be empty")
    }

    if (!discountVal) {
        throw new Error("Discount value cannot be empty")
    }

    let endpoint = `${environment.API_URL}/discount_label/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        discount_label: discountLabel,
        discount: discountVal,
    }

    let response = await fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for get discount label list **/

export async function getDiscountList(token) {
    let endpoint = `${environment.API_URL}/discount_label/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for update discount label **/

export async function updateDiscountLabel(token, discountLabelId, discountVal) {
    if (!discountLabelId) {
        throw new Error("Discount label id cannot be empty")
    }

    if (!discountVal) {
        throw new Error("Discount value cannot be empty")
    }

    let endpoint = `${environment.API_URL}/discount_label/${discountLabelId}/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        discount: discountVal,
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for active/inactive discount label **/

export async function activeDiscountLabel(token, discountLabelId, discounLabelStatus) {
    if (!discountLabelId) {
        throw new Error("Discount label id cannot be empty")
    }

    let endpoint = `${environment.API_URL}/discount_label/${discountLabelId}/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        is_active: discounLabelStatus,
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create download invoice for support user  **/

export async function downloadInvoice(token, dealerTeamId, invoiceNo, downloadInvoiceNo, downloadType="Invoice", listControllers=[]) {

    let endpoint = `${environment.API_URL}/subs_download_invoice/?invoice_team=${dealerTeamId}&invoice_number=${invoiceNo}&download_type=${downloadType}&list_controllers=${listControllers.join(',')}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create customer for ACH payment method  **/

export async function addAchCustomer(token, sourceId, descVal) {

    let endpoint = `${environment.API_URL}/subs_ach_customer/?source_token=${sourceId}&description=${descVal}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}


/** API for verify ACH customer for ACH payment method  **/

export async function verifyAchCustomer(token, custId, sourceId) {
    if (!custId) {
        throw new Error("Customer id cannot be empty")
    }
    if (!sourceId) {
        throw new Error("Source id cannot be empty")
    }
    let endpoint = `${environment.API_URL}/subs_ach_verify/?customer_id=${custId}&source_token=${sourceId}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create charge for ACH payment method  **/

export async function achPaymentCharge(token, customerId, amount) {
    if (!customerId) {
        throw new Error("Customer id cannot be empty")
    }
    if (!amount) {
        throw new Error("Amount cannot be empty")
    }

    let endpoint = `${environment.API_URL}/subs_ach_charge/?customer_id=${customerId}&amount=${amount}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create get all expired controllers for report **/

export async function subsExpiredControllers(token) {

    let endpoint = `${environment.API_URL}/subs_expired_controllers/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    console.log(data);
    return data
}

/** API for create get all abount expire controllers (less than 60 days) for report **/

export async function subsAboutExpireControllers(token) {

    let endpoint = `${environment.API_URL}/subs_about_expired_controllers/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    console.log(response)
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    console.log(data)
    return data
}

/** API for create get all payments for given month for report **/

export async function subsPaymentsReport(token, startDateVal, endDateVal) {
    if (!startDateVal) {
        throw new Error("Start date cannot be empty")
    }
    if (!endDateVal) {
        throw new Error("End date cannot be empty")
    }

    let endpoint = `${environment.API_URL}/subs_payments_report/?startdate=${startDateVal}&enddate=${endDateVal}`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for create get all renewed controllers for report **/

export async function subsRenewedController(token) {

    let endpoint = `${environment.API_URL}/subs_renewed_controllers/`

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API for update about expire days **/

export async function updateAboutExpireDays(token, defaultPkId, expireDaysTxtVal) {

    if (!expireDaysTxtVal) {
        throw new Error("About expire days value cannot be empty")
    }

    let endpoint = `${environment.API_URL}/set_about_expire_days/`
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let newField = {
        "id": defaultPkId,
        "expiring_days": expireDaysTxtVal
    }

    let response = await fetch(endpoint, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(newField)
    })

    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}


function checkSerializedResponseForErrors(response) {
    if (response.error) {
        throw new Error(`${response.error}: ${response.error_description}`)
    } else if (response.detail) {
        throw new Error(`${response.detail}`)
    } else {
        return response
    }
}

/** API for share quote **/

export async function shareSubscriptionQuote(token, controllerIDs, invoice_number, email, download=false, dealerTeamId) {

    let endpoint
        endpoint = `${environment.API_URL}/subs_send_quote/?controller_ids=${controllerIDs.join(',')}&invoice_number=${invoice_number}&email=${email}&dealer_teams=${dealerTeamId}`
        if (download) {
            endpoint = endpoint + '&download=true'
        }
    

    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}

/** API generate invoice from quote **/

export async function getTeamsByQuoteNumber(token, quote_number) {

    let endpoint
        endpoint = `${environment.API_URL}/subs_get_team_from_quote/?quote_number=${quote_number}`
   
    let headers = new Headers()
    headers.append('Authorization', `Bearer ${token.accessToken}`)
    headers.append('Content-Type', 'application/json')

    let response = await fetch(endpoint, {
        method: 'GET',
        headers: headers
    })
    await checkServerResponseForErrors(response)
    const data = await response.json()
    checkSerializedResponseForErrors(data)
    return data
}



// WEBPACK FOOTER //
// ./src/api.js